import React from "react";
import { Line as KonvaLine } from "react-konva";
const CanvasGrid = () => {
	const gridSize = 20;
	const width = window.innerWidth;
	const height = window.innerHeight;
	const lines = [];

	for (let i = 0; i < width / gridSize; i++) {
		lines.push(
			<KonvaLine
				key={`v-${i}`}
				points={[i * gridSize, 0, i * gridSize, height]}
				stroke="#ddd"
				strokeWidth={1}
			/>
		);
	}

	for (let j = 0; j < height / gridSize; j++) {
		lines.push(
			<KonvaLine
				key={`h-${j}`}
				points={[0, j * gridSize, width, j * gridSize]}
				stroke="#ddd"
				strokeWidth={1}
			/>
		);
	}

	return lines;
};
export default CanvasGrid;
